import authorized from "@/middleware/authorized"
import paid from '@/middleware/paid'

export default {

    path: '/crm',
    meta: { middleware: [authorized, paid], layout: "default", rights: ['tasks'] },
    component: () => import('../components/pages/crm/CRMGeneral.vue'),
    children: [
        { path: '', redirect: '/crm/funnel_applications' },
        {
            path: 'funnel_applications', name: "CRMSalesFunnelApplications",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['crm'] },
            component: () => import('../components/pages/crm/CRMSalesFunnelApplications.vue')
        },
        {
            path: 'tasks', name: "CRMTasks",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['tasks'] },
            component: () => import('../components/pages/crm/CRMTasks.vue')
        },
        {
            path: 'visits', name: "CRMVisits",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['tasks'] },
            component: () => import('../components/pages/crm/CRMVisits.vue')
        },
        {
            path: 'sales', name: "CRMSalesFunnel",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['crm'] },
            component: () => import('../components/pages/crm/CRMSalesFunnel.vue')
        },
        {
            path: 'funnel_plans', name: "CRMSalesFunnelPlans",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['crm'] },
            component: () => import('../components/pages/crm/CRMSalesFunnelPlans.vue')
        },
        {
            path: 'funnel_patients', name: "CRMFunnelPatients",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['crm'] },
            component: () => import('../components/pages/crm/CRMFunnelPatients.vue')
        },
        {
            path: 'funnel_patients/:canbanId', name: "CRMFunnelPatientPage",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['crm'] },
            component: () => import('../components/pages/crm/CRMFunnelPatientPage.vue')
        },
        {
            path: 'applications', name: "CRMApplications",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['crm'] },
            component: () => import('../components/pages/crm/CRMApplications.vue')
        },
        {
            path: 'forms', name: "CRMForms",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['crm'] },
            component: () => import('../components/pages/crm/CRMForms.vue')
        },
        {
            path: 'feedbacks', name: "CRMFeedbacks",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['view_feedbacks'] },
            component: () => import('../components/pages/crm/CRMFeedbacks.vue')
        },
        {
            path: 'settings', name: "CRMSettings",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['crm'] },
            component: () => import('../components/pages/crm/CRMSettings.vue')
        },
        {
            path: 'lead/:id', name: "CRMLeadPage",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['crm'] },
            component: () => import('../components/pages/crm/CRMLeadPage.vue')
        },
    ]
}
